import React from "react";
import PropTypes from "prop-types";

/**
 * Shared CRUD page title with optional total count.
 * Usage: <PageWrapper title="Symptom Management" totalCount={totalCount} loading={loading} />
 */
export default function PageWrapper({ title, totalCount, loading = false, children }) {
    const showTotal = !loading && totalCount != null && totalCount !== "";

    return (
        <div className="welcome-title d-flex justify-content-between align-items-center">
            <h2>
                {title}
                {showTotal ? (
                    <span className="page-wrapper__total nhsuk-u-font-size-19 nhsuk-u-font-weight-normal">
                        {" "}— Total: {totalCount}
                    </span>
                ) : null}
            </h2>
            {children}
        </div>
    );
}

PageWrapper.propTypes = {
    title: PropTypes.string.isRequired,
    totalCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    loading: PropTypes.bool,
    children: PropTypes.node,
};
